import { render, staticRenderFns } from "./modal-view-hipres-step-three.vue?vue&type=template&id=515a5fbe&scoped=true"
import script from "./modal-view-hipres-step-three.vue?vue&type=script&lang=js"
export * from "./modal-view-hipres-step-three.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "515a5fbe",
  null
  
)

export default component.exports